'use strict';

/* jshint -W098 */
angular.module('mean.foreman').controller('ForemanSetupInventoryController', ['$scope', 'Users', 'Global', 'MeanUser', 'ProjectContacts', 'toaster', '$filter', 'foremanPhaseService', 'aceUtils',
	function ($scope, Users, Global, MeanUser, ProjectContacts, toaster, $filter, foremanPhaseService, aceUtils) {
		$scope.global = Global;
		$scope.package = {
			name: 'foreman'
		};

		$scope.user = MeanUser.user;

		$scope.my_bids = $scope.$parent.my_bids;
		$scope.selectedProject = $scope.$parent.selectedProject;

		ProjectContacts.query({ 'project_id': $scope.selectedProject._id }, function (contact) {
			if (contact.length === 1) {
				$scope.contact = contact[0];
			} else if (contact.length === 0) {
				$scope.contact = new ProjectContacts({
					project_id: $scope.selectedProject._id,
					company_emails: [],
					material_suppliers: [],
					equipment_suppliers: []
				});

				$scope.contact.$save();
			} else {
				toaster('error', 'Database Error', 'Project contacts.');
			}

			$scope.contactsFromBids();
		});

		$scope.contactsFromBids = function () {
			var names = foremanPhaseService.getMaterialSuppliers($scope.my_bids);
			var isInventoryAdded = false;
			var checkSaved = $filter('filter')($scope.contact.material_suppliers, {
				'isInventory': true,
			}, true);
			(checkSaved.length !== 0) && (isInventoryAdded = true);
			for (var i in names) {
				var inlist = $filter('filter')($scope.contact.material_suppliers, {
					'name': names[i].name,
					'isInventory': names[i].isInventory,
				}, true);

				if (inlist.length === 0) {
					if (!isInventoryAdded && names[i].isInventory) {
						$scope.contact.material_suppliers.push({
							name: names[i].name,
							isInventory: names[i].isInventory || false,
							emails: []
						});
						isInventoryAdded = true;
					} else if (!names[i].isInventory) {
						$scope.contact.material_suppliers.push({
							name: names[i].name,
							isInventory: names[i].isInventory || false,
							emails: []
						});
					}
				}
			}

			names = foremanPhaseService.getEquipmentSuppliers($scope.my_bids);

			for (var i in names) {
				var inlist = $filter('filter')($scope.contact.equipment_suppliers, {
					'name': names[i]
				}, true);
				if (inlist.length === 0) {
					$scope.contact.equipment_suppliers.push({
						name: names[i],
						emails: []
					});
				}
			}
		};

		$scope.addEmail = function (sup, email) {
			if (aceUtils.isUndefinedOrNull(email)) return;

			if (sup.emails.indexOf(email) === -1)
				sup.emails.push(email);

			$scope.updateContacts();

			this.newEmail = '';
		};

		$scope.addCompanyEmail = function (newCompanyEmail) {
			if (aceUtils.isUndefinedOrNull(newCompanyEmail)) return;

			$scope.contact.company_emails.push(newCompanyEmail);

			$scope.updateContacts();

			this.newCompanyEmail = '';
		};

		$scope.viewDetails = function (type, sup, index, text) {
			//this function gets called when the email modal is active
			//and sets some global variables for the edit functions
			$scope.editEmailType = type;
			$scope.editEmailSup = sup;
			$scope.editEmailIndex = index;
			$scope.editEmailText = text;
		};

		$scope.acceptEditEmail = function () {
			if ($scope.editEmailType === 0) {
				$scope.editEmailSup.company_emails[$scope.editEmailIndex] = $scope.editEmailText;
			} else {
				$scope.editEmailSup.emails[$scope.editEmailIndex] = $scope.editEmailText;
			}

			$scope.updateContacts();
		};

		$scope.cancelEditEmail = function () {
		};

		$scope.deleteEmail = function () {
			if ($scope.editEmailType)
				$scope.editEmailSup.emails.splice($scope.editEmailIndex, 1);
			else
				$scope.editEmailSup.company_emails.splice($scope.editEmailIndex, 1);

			$scope.updateContacts();
		};

		$scope.updateContacts = function () {
			$scope.contact.$update(function (results) {
				$scope.contact = results
				toaster.pop('success', 'Contact Database', 'Email contacts saved');
			}, function (error) {
				toaster.pop('error', 'Contact Database', error);
			});
		};
	}
]);



// WEBPACK FOOTER //
// ./packages/custom/foreman/public/controllers/foremanSetupInventory.js